import React from "react";
import { Card, Avatar, Spin, Empty } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface IssueFixer {
  user: string;
  count: number;
}

interface TopIssueFixersProps {
  loading: boolean;
  data: IssueFixer[] | null;
}

const TopIssueFixers: React.FC<TopIssueFixersProps> = ({ loading, data }) => {
  const getInitials = (name: string) => {
    const parts = name?.trim().split(" ");
    return parts.length >= 2
      ? parts[0][0] + parts[1][0]
      : name.substring(0, 2).toUpperCase();
  };

  // Limit data to only top 5 items
  const topFiveData = data ? data.slice(0, 5) : [];

  return (
    <>
      {loading ? (
        <div
          style={{
            height: 220,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin indicator={<LoadingOutlined spin style={{ fontSize: 24 }} />} />
        </div>
      ) : !topFiveData || topFiveData.length === 0 ? (
        <div
          style={{
            height: 220,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="No achievers yet" />
        </div>
      ) : (
        <div>
          {topFiveData.map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 0",
                borderBottom:
                  index < topFiveData.length - 1 ? "1px solid #f0f0f0" : "none",
              }}
            >
              <Avatar style={{ backgroundColor: "#1890ff", marginRight: 12 }}>
                {getInitials(item.user)}
              </Avatar>
              <div style={{ flex: 1 }}>{item.user}</div>
              <div style={{ fontWeight: 500 }}>{item.count}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default TopIssueFixers;
